/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Grid, Row, Col } from 'react-bootstrap';
import s from './ServicesLayout.css';
import s2 from './ServicesLayout2.scss';
import ServicesHeader from '../ServicesHeader/ServicesHeader';
import ServicesFooter from '../ServicesFooter/ServicesFooter';
import SideBarContainer from '../SideBarMenu/SideBarContainer';
import SideBarButton from '../SideBarMenu/SideBarButton';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import { adminRole } from '../../config';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage, getCurrentDistrict } from '../utils/utils';
import { RODO_CONTENT, RODO_CONTENT_OLSZTYN } from '../utils/RODO';

const ModalInfo = (props) => {
  return (
    <Modal name={props.name} show={props.show} onHide={props.onHide}>
      <Modal.Header closeButton style={{ color: layoutColorStyle[props.colors].color, backgroundColor: layoutColorStyle[props.colors].backgroundColor }}>
        <Modal.Title ><h4 style={{ textAlign: 'center' }}>{props.title}</h4></Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto', color: layoutColorStyle[props.colors].color, backgroundColor: layoutColorStyle[props.colors].backgroundColor }}>
        {props.bodyText}
      </Modal.Body>
      <Modal.Footer style={{ color: layoutColorStyle[props.colors].color, backgroundColor: layoutColorStyle[props.colors].backgroundColor }}>
        <Button className="btn btn-primary center-block" onClick={props.onSave} >Zapoznałem się</Button>
      </Modal.Footer>
    </Modal>
  );
};

const centerDiv = {
  margin: 'auto',
  maxWidth: '1040px',
  paddingBottom: '30px',
};

const SprDostMaterialowDiv = {
  margin: 'auto',
  maxWidth: '1800px',
  paddingBottom: '30px',
}

const rodoDict = {
  28: RODO_CONTENT_OLSZTYN,
}

class ServicesLayout extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  state = {
    colors: 'normal',
    viewPopup: true,
    district: null,
  }

  componentDidMount() {
    this.setCurrentDistrict();
    this.setPopupInfo();
    this.setTheme();
  }

  setCurrentDistrict() {
    getCurrentDistrict()
    .then((district) => {
      this.setState({ district });
    });
  }

  setPopupInfo = () => {
    const visited = localStorage["popupAccepted"];
    if (visited) {
      this.setState({ viewPopup: false });
    }
  }

  setTheme = () => {
    const colors = getThemeFromLocalStorage();
    this.setState({ colors });
  }

  setColors = (colors) => {
    localStorage.setItem('colorTheme', colors);
    window.location.reload();
  }

  handleSave = () => {
    localStorage["popupAccepted"] = true;
    this.setState({ viewPopup: false });
  }

  handleHide = () => {
    this.setState({ viewPopup: false })
  }

  render() {
    let isSprDostMaterialowService = false;
    if (typeof window !== "undefined") {
      isSprDostMaterialowService = window.location.href.includes('SprDostMaterialow');
    }
    return <div id="layout-body" style={{ paddingBottom: this.props.footerHeight, fontSize: this.props.fontSize + 'rem', height: '100%', color: layoutColorStyle[this.state.colors].color, backgroundColor: layoutColorStyle[this.state.colors].backgroundColor }}>
      <ServicesHeader setColors={this.setColors} colors={headerStyle[this.state.colors]} {...this.props} />
      {
        this.state.viewPopup &&
        <ModalInfo
          title={"Przeczytaj, jak przetwarzamy twoje dane"}
          bodyText={(this.state.district in rodoDict) ? rodoDict[this.state.district] : RODO_CONTENT}
          show={this.state.viewPopup}
          name="viewPopupModal"
          onSave={this.handleSave}
          colors={this.state.colors}
          onHide={this.handleHide}
        />
      }
      {
        this.props.sidePanel ?
          <Grid style={{ width: '100%' }}>
            <Row>
              <Col xs={12} sm={2}>
                <SideBarContainer width={100}>
                  <SideBarButton colorStyle={headerStyle[this.state.colors]} link={`/panel`} active={this.props.active_panel && this.props.active_panel === 'moje_dane' ? true : false} text="Moje dane" icon="fa-home" />
                  <SideBarButton colorStyle={headerStyle[this.state.colors]} link={`/panel/${this.props.username}/mojedokumenty`} active={this.props.active_panel && this.props.active_panel === 'dokumenty' ? true : false} text="Zamówione materiały" icon="fa-file-text" styl="meledutki" />
                  <SideBarButton link={`/panel/${this.props.username}/usunkonto`} active={this.props.active_panel && this.props.active_panel === 'usun_konto' ? true : false} text="Usuń konto" icon="fa-trash" styl="meledutki" />
                  <SideBarButton colorStyle={headerStyle[this.state.colors]} link={`/panel/${this.props.username}/mojezapytania`} active={this.props.active_panel && this.props.active_panel === 'moje_zapytania' ? true : false} text="Moje zapytania" icon="fa-envelope" styl="meledutki" />
                </SideBarContainer>
                { this.props.userRoles.indexOf(adminRole) >= 0 ?
                <SideBarContainer width={100}>
                  <SideBarButton colorStyle={headerStyle[this.state.colors]} link={`/panel/${this.props.username}/statusgmin`} active={this.props.active_panel && this.props.active_panel === 'status_gmin' ? true : false} text="Status gmin" icon="fa-home" />
                </SideBarContainer>: null}
              </Col>
              <Col className="rwd-class" xs={12} sm={10}>{this.props.children}</Col>
            </Row>
          </Grid> :
          <div>
            <Row style={isSprDostMaterialowService ? SprDostMaterialowDiv : centerDiv}>
              <Col className="rwd-class" xs={12}>{this.props.children}</Col>
            </Row>
          </div>
      }
      {!this.props.withoutFooter ? <ServicesFooter colors={headerStyle[this.state.colors]} absoluteFooter={this.props.absoluteFooter} {...this.props} /> : null}
    </div>;
  }
}

const mapState = (state) => ({
  fontSize: state.runtime.fontSize,
  username: state.user ? state.user.username : null,
  footerHeight: state.eservices.footerHeight,
  userRoles: (state.user && state.user.roles !== undefined) ? state.user.roles : [],
});

export default withStyles(s, s2)(connect(mapState)(ServicesLayout));



// WEBPACK FOOTER //
// src/components/ServicesLayout/ServicesLayout.js